export const related = [
  '/build-planner',
  '/abilities/ignite-vs-inferno',
  '/abilities',
];
export const quickAnswer =
  'Ground Slam fits an aggressive aerial approach; Push fits simpler ranged control. Choose the action that matches your movement habits.';
export const sourceIds = ['gamesradar-abilities', 'ps-ngplus'];
export const table = {
  headers: ['Ability', 'Fit', 'Trade-off'],
  rows: [
    [
      'Ground Slam',
      'Aerial, aggressive play',
      'Best suited to a player who wants to commit to aerial attacks.',
    ],
    [
      'Push',
      'Ranged control',
      'A simpler fit when you prefer controlling space at a distance.',
    ],
  ],
};

## Ground Slam vs Push Comparison

This choice follows the Dancer Resonant. Both are valid directions; the meaningful distinction is how you want to approach enemies.

## When Ground Slam Fits

Choose Ground Slam if aerial attacks are already part of your routine. An option that complements a habit is easier to incorporate than one chosen only because it sounds stronger.

## When Push Fits

Choose Push when straightforward ranged control is your priority. It may suit a player who wants an easier decision while learning an encounter.

## Which One Should You Pick?

Ask what you do when pressured: move into an aerial attack, or create room from a distance? Use that answer as your starting point, not as a permanent rule.

## Respec and NG+ Notes

Combat choices can be reset at The Gap using a Reset Item. New Game Plus carries combat abilities forward; compare your available options in-game before changing an established setup.
